export default __webpack_public_path__ + "static/media/verified-false.7b079d2f.svg";